import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id", "accept"]
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "text-sm font-bold"
}
const _hoisted_4 = { class: "my-2 border-4 px-3 py-2 border-teal-500 border-dashed" }
const _hoisted_5 = {
  key: 0,
  class: "text-red-800 text-sm ml-0.5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col py-2 px-3 relative w-full", _ctx.tclass])
  }, [
    _createElementVNode("label", null, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            icon: "sync-alt",
            spin: ""
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "relative w-full flex flex-col",
      onDragover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args))),
      onDragleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args))),
      onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
    }, [
      _createElementVNode("input", {
        type: "file",
        class: "w-px h-px opacity-0 overflow-hidden absolute",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
        name: "fname",
        id: 'fileField' + _ctx.name,
        ref: "file",
        accept: _ctx.accept
      }, null, 40, _hoisted_1),
      _createElementVNode("label", {
        for: 'fileField' + _ctx.name,
        class: "block cursor-pointer"
      }, [
        (_ctx.fileName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Arquivo selecionado: " + _toDisplayString(_ctx.fileName), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.msgArrastar ? _ctx.msgArrastar : "Arraste aqui ou clique para adicionar um arquivo"), 1)
      ], 8, _hoisted_2)
    ], 32),
    (_ctx.error && _ctx.error.length > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 2))
}